import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const schemaItems = items.map((item, index) => ({
    '@type': 'ListItem' as const,
    position: index + 1,
    item: item.to
      ? { '@id': `https://baisifashion.com${item.to}`, name: item.label }
      : { name: item.label },
  }));

  return (
    <>
      <nav aria-label="面包屑导航" className="py-3">
        <ol className="flex flex-wrap items-center gap-1 text-sm">
          {items.map((item, index) => (
            <li key={index} className="flex items-center gap-1">
              {index > 0 && (
                <span className="text-foreground-400 mx-1">
                  <i className="ri-arrow-right-s-line text-xs"></i>
                </span>
              )}
              {item.to ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: schemaItems,
          }),
        }}
      />
    </>
  );
}